import React from 'react'
import PropTypes from 'prop-types'

const LocationId = ({ number }) => (
  <div>{number}</div>
)

LocationId.propTypes = {
  number: PropTypes.string.isRequired
}
LocationId.defaultProps = {}

export default LocationId
